import { BaseIcon, BaseIconProps } from "@/shared/icons/BaseIcon";

export function SBankLogo({ ...props }: BaseIconProps) {
  return (
    <BaseIcon viewBox="0 0 105 24" className="w-[105px] h-[24px]" {...props}>
      <path
        fill="currentColor"
        d="M38.39 15.52a5.5 5.5 0 0 1-2.67.68 4.63 4.63 0 0 1-4.8-4.77 4.63 4.63 0 0 1 4.8-4.78c1-.02 1.99.3 2.8.9l2.23-1.66-.14-.14A7.29 7.29 0 0 0 35.63 4a7.9 7.9 0 0 0-5.47 2.06A7.16 7.16 0 0 0 28 11.33a7.5 7.5 0 0 0 2.16 5.37 7.69 7.69 0 0 0 5.45 2.13 7.3 7.3 0 0 0 5.47-2.2l-1.99-1.5-.7.39ZM74.25 4.21v14.45h3.08v-5.91h6.58v5.91h3.08V4.21h-3.08v5.94h-6.58V4.2h-3.08Zm-5.31 14.45h3.25L66.15 4.21h-3.13l-6.15 14.45h3.1l1.25-2.9h6.55l1.17 2.9Zm-6.79-5.32 2.39-5.8 2.24 5.8h-4.63Zm31.77-.52h1.92l4.72 5.82h3.98l-6.32-7.48 5.52-6.97h-3.53l-4.58 6.2h-1.71v-6.2h-3.09v14.45h3.09v-5.82ZM46.67 9.84V6.63h8.07V4.2H43.58v14.45H50c3.6 0 5.69-1.65 5.69-4.54 0-2.77-1.88-4.28-5.3-4.28h-3.73Zm0 2.41h3.22c1.97 0 2.88.67 2.88 2.01 0 1.35-.96 2.01-2.88 2.01h-3.22v-4.02Z"
      />
      <mask
        id="a"
        width="24"
        height="24"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
      >
        <ellipse cx="11.85" cy="12" fill="#d9d9d9" rx="11.85" ry="12" />
      </mask>
      <g mask="url(#a)">
        <path
          fill="currentColor"
          d="M24.26 2.88c.56.74 1.03 1.54 1.43 2.39l-13.8 11.66-4.55-3.48V10l4.52 3.46 12.4-10.58Z"
        />
      </g>
      <path
        fill="currentColor"
        d="M2.74 12.01c0-.16 0-.3.02-.47L.02 11.4l-.02.59c0 3.31 1.33 6.31 3.49 8.49l1.94-1.97a9.14 9.14 0 0 1-2.7-6.5Zm9.12-9.21.47.01.14-2.76-.59-.03a11.8 11.8 0 0 0-8.4 3.53L5.44 5.5a8.99 8.99 0 0 1 6.43-2.72Zm0 18.43c-.16 0-.3 0-.47-.02l-.14 2.77.59.02c3.27 0 6.24-1.35 8.4-3.52l-1.95-1.97a8.86 8.86 0 0 1-6.43 2.72Z"
      />
      <path
        fill="currentColor"
        d="m17 4.4 2.32-1.73A11.8 11.8 0 0 0 11.86 0v2.77c1.92.02 3.7.61 5.15 1.63Zm-5.14 16.83a9.02 9.02 0 0 1-6.76-3.05l-2.04 1.87a11.75 11.75 0 0 0 8.8 3.95v-2.77ZM5.75 5.18 3.91 3.12A11.99 11.99 0 0 0 0 12.02h2.74c0-2.7 1.17-5.16 3.01-6.84Z"
      />
    </BaseIcon>
  );
}
